import { pathFromCubics } from "../ctors/path";
import { copyAttribs } from "../internal/copy-attribs";
import { asCubic } from "./as-cubic";
export const asPath = (src, attribs) => pathFromCubics(asCubic(src), attribs || copyAttribs(src));
